module.exports = __webpack_public_path__ + "assets/filtered-0991e9.svg";